import type { StateCreator } from "zustand";
import type { Environment } from "@/repositories/process/types";

export interface EnvironmentSliceState {
  environment: Environment | undefined;
}

interface EnvironmentSliceActions {
  setEnvironment: (
    nextEnvironment:
      | EnvironmentSliceState["environment"]
      | ((
          currentEnvironment: EnvironmentSliceState["environment"]
        ) => EnvironmentSliceState["environment"])
  ) => void;
}

export type EnvironmentSlice = EnvironmentSliceState & EnvironmentSliceActions;

export const createEnvironmentSlice: StateCreator<
  EnvironmentSlice,
  [["zustand/devtools", never]],
  [],
  EnvironmentSlice
> = (set) => ({
  environment: undefined,
  setEnvironment: (nextEnvironment) =>
    set((state) => ({
      environment:
        typeof nextEnvironment === "function"
          ? nextEnvironment(state.environment)
          : nextEnvironment,
    })),
});
